import React from 'react'

import { data } from './data'

import styles from './styles.module.scss'

export const View = () => {
	return (
		<article>
			<h2 className={styles.heading}>{data.heading}</h2>
			<div className={styles.contentWrapper}>
				{data.content.map((el) => (
					<p key={el} className={styles.content}>
						{el}
					</p>
				))}
			</div>
		</article>
	)
}
